import {Pipe, PipeTransform} from '@angular/core';
import {Permission} from 'smag-commons/dto/api';

@Pipe({name: 'permissionName'})
export class PermissionNamePipe implements PipeTransform {

    constructor() {
    }

    transform(permission: Permission): string {
        switch (permission) {
            case Permission.CREATE:
                return 'CREATE';
            case Permission.READ:
                return 'READ';
            case Permission.UPDATE:
                return 'UPDATE';
            case Permission.DELETE:
                return 'DELETE';
            case Permission.OPERATE:
                return 'OPERATE';
            case Permission.PERMISSIONS:
                return 'PERMISSIONS';
            case Permission.ALL:
                return 'ALL';
            default:
                return permission;
        }
    }
}

@Pipe({name: 'permissionIcon'})
export class PermissionIconPipe implements PipeTransform {

    constructor() {
    }

    transform(permission: Permission): string {
        switch (permission) {
            case Permission.CREATE:
                return 'fal-plus-square';
            case Permission.READ:
                return 'fal-book-open';
            case Permission.UPDATE:
                return 'fal-edit';
            case Permission.DELETE:
                return 'fal-trash-alt';
            case Permission.OPERATE:
                return 'fal-terminal';
            case Permission.PERMISSIONS:
                return 'fal-users';
            case Permission.ALL:
                return 'fal-globe';
            default:
                return permission;
        }
    }
}

@Pipe({name: 'permissionDescription'})
export class PermissionDescriptionPipe implements PipeTransform {

    constructor() {
    }

    transform(permission: Permission): string {
        switch (permission) {
            case Permission.CREATE:
                return 'The permission to create some entity';
            case Permission.READ:
                return 'The permission to read some entity';
            case Permission.UPDATE:
                return 'The permission to update some entity';
            case Permission.DELETE:
                return 'The permission to delete some entity';
            case Permission.OPERATE:
                return 'The permission to control or actuate some entity';
            case Permission.PERMISSIONS:
                return 'The permission to assign permissions on some entity';
            case Permission.ALL:
                return 'All supported permissions';
            default:
                return '';
        }
    }
}
